<script>
import config from "./../../config.js";
import { user } from './../stores.js';

let current_user;
const unsubscribe = user.subscribe(value => {
    current_user = value;
});
const device = 'laitdepoule';

function getCurrReadings() {

  const payload = {
    "hours": 24,
    "types": ["temperature"],
    "devices": [device]
  }

  const options = {
    method: 'POST',
    body: JSON.stringify(payload),
    headers: {
    'Content-Type': 'application/json'
    }
  }
  if (current_user.token) {
    options.headers['authorization'] = "Bearer " + current_user.token;
  }  

  return new Promise(fulfil => {
    const { latest } = config;

    fetch(latest["url"], options)
      .then(res => {
        if (res.status === 401) {
          console.error("401. Unable to retrieve current sensor readings.")
        }
        if (res.status === 404) {
          console.error("404. Unable to retrieve current sensor readings.")
        }
        if (!res.ok) {
          console.error("Error. Unable to retrieve current sensor readings.")
        }
        return res.json();
      })
      .then(res => {
        if (!res || !res["temperature "+device] || typeof res["temperature "+device]['y'][0] == 'undefined') {
            return;
        }
        return res;
      })
      .then(res => {
        fulfil(res);
      })
      .catch(error => console.error(error));
  })
};
</script>
<style>
h2 {
    margin-top: 0;
    margin-bottom: 0;
}
</style>
<h2>
    {#await getCurrReadings()}
      <span class="temperature">-°c</span>
    {:then data}
    	&#x2745;
      <span class="temperature">{parseFloat(data["temperature "+device]['y'][0]).toFixed(1)}°c</span>
    {:catch error}
      <span class="temperature">-°c</span>
    {/await}
  </h2>